export const checkUrl = (url) =>
  /https?/.test(url) ? url : process.env.REACT_APP_API_URL + url;

export const fixYouTubeUrl = (url = "") =>
  url.indexOf("watch") !== -1 ? url.replace("watch?v=", "embed/") : url;
